import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import {
  TaskDetailsService,
  TaskDetailsState,
} from '../../../task-details.service';

@Directive()
export abstract class BaseStepperAction implements OnInit, OnDestroy {
  abstract get enabled(): boolean;

  subscription: Subscription;

  state: TaskDetailsState;

  constructor(protected readonly taskDetailsService: TaskDetailsService) {}

  ngOnInit(): void {
    this.state = this.taskDetailsService.state;
    this.subscription = this.taskDetailsService.state$.subscribe((state) => {
      this.state = state;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  /**
   * Reloads the sheet. `notifyHost` for a change the affaire's own status does
   * not show — the host list would otherwise keep the row as it was.
   */
  refreshTaskDetails(notifyHost = false) {
    this.taskDetailsService.refreshTaskDetails();
    if (notifyHost) this.taskDetailsService.notifyChanged();
  }
}
